import { Mp4WasmEncoderConfig } from '@/pixi/types'

/**
 * Documentation around codecs here https://serato.atlassian.net/wiki/spaces/DEV/pages/7502955182/OS+codec+support
 */
const highAVCCodecs = ['avc1.64002a', 'avc1.640032', 'avc1.640033', 'avc1.640034']
const mainAVCCodecs = ['avc1.4d002a', 'avc1.4d0032', 'avc1.4d0033', 'avc1.4d0034']
const baselineAVCCodecs = ['avc1.42002a', 'avc1.420032', 'avc1.420033', 'avc1.420034']

const possibleSupportedCodecs = highAVCCodecs.concat(mainAVCCodecs.concat(baselineAVCCodecs))

async function getSupportedCodec (width: number, height: number, framerate: number): Promise<string> {
  for (const codec of possibleSupportedCodecs) {
    const config: VideoEncoderConfig = {
      codec,
      height,
      width,
      framerate,
      avc: {
        format: 'avc'
      }
    }
    
    const support = await VideoEncoder.isConfigSupported(config)
    if (support.supported) {
      return codec
    }
  }
  throw new Error('Could not find a supported avc codec')
}

export async function getEncoderConfig (width: number, height: number, framerate: number): Promise<Mp4WasmEncoderConfig> {
  return {
    fps: framerate,
    width: width,
    height: height,
    format: 'avc',
    codec: await getSupportedCodec(width, height, framerate)
  }
}